import { Spin } from 'antd';

import LoadingBar from './ProcessBar';

interface LoadingProps {
  Bar: typeof LoadingBar;
}

const Loading: React.FC & LoadingProps = () => {
  return <Spin />;
};

Loading.Bar = LoadingBar;

export default Loading;
